import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var EmailIcon = function EmailIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.65 6L12 11.088 19.35 6H4.65zm16.792-1.434a.75.75 0 0 1 .992.992A1.5 1.5 0 0 1 22.5 6v12a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 18V6a1.5 1.5 0 0 1 .066-.442.75.75 0 0 1 .992-.992A1.5 1.5 0 0 1 3 4.5h18a1.5 1.5 0 0 1 .442.066zM21 6.681l-8.573 5.936a.75.75 0 0 1-.854 0L3 6.68V18h18V6.681z"
  }));
};

EmailIcon.displayName = 'EmailIcon';
export default EmailIcon;